import * as React from 'react';
import {getHostApi} from "../../../utils";
import {getUserId} from "../MonCompteAction";
import {useState} from "react";
import Modal from "react-responsive-modal";
import Icons from '../Icons';

interface EmbroderyProps {
  data: Record<any, any>
  idCaddies: number
  surfaceEmplacementId: number
}

export const Embrodery  = (props: EmbroderyProps) => {
  const filsBroderie = props.data.broderie[props.idCaddies][props.surfaceEmplacementId];
  const broderieMiniatureSrc = null;
  const [displayFils, setDisplayFils] = useState<boolean>(false);

  const routeMiniatureFils = `${getHostApi()}/customers/${getUserId()}/orders/${props.data.idCommande}/image-files?numCommande=${props.data.numCommande}&path=travail.auto/embroidery/&validated=true&xsrf=${localStorage.getItem('xsrfToken')}&cache=${Date.now()}`;
  const urlMiniaPrincipale = `${routeMiniatureFils}&nom=${filsBroderie[0]?.fichierBroderiePrincipal}`;

  const renderListeFils = () => {
    const html = [];
    for (const data of filsBroderie) {
      const urlMinia = `${routeMiniatureFils}&nom=${data.fichierBroderie}&cache=${Date.now()}`;
      data.url = urlMinia;
      html.push(
        <>
          <div className={"mx-1 my-3 outlineCCC p-1"} style={{maxWidth: 250}}>
            <img src={`${data.url}`} className={"p-1"} style={{background: `#${props.data.code1}`}}/>
            <div className={"text-center"}>
                  <span className={"pl2 pr2"} title={`Hexadecimal : #${data.hexa}`}
                        style={{border: "1px solid black", backgroundColor: `#${data.hexa}`}}>&nbsp;</span>
              <span className={"pl1"}>{data.libelle} - Polyneon 40 n°<span className={"bold"}>{data.madeira}</span>{data.fluorescent !== 0 ? " - fluorescent": ""}{data.madeira > 3999 && data.madeira < 5000 ? " - métallique" :""}</span>
            </div>
          </div>
        </>,
      );
    }
    return (html);
  }

  const renderModal = () => {
    return (
      <Modal open={displayFils} onClose={() => {setDisplayFils(!displayFils)}} center   classNames={{overlay: 'bootstrap-container', modal: 'batModalContainer',  closeButton: 'batModalCloseButton closeButton '}}>
        <div className={"d-flex flex-column align-items-center border-bottom pb-2 mb-2"}>
          <div >
            <img className={"bg-alpha-bat-auto p-3"} id="miniatureBroderie" src={`${broderieMiniatureSrc ?? urlMiniaPrincipale}`} style={{background: `#${props.data.code1}`}}/>
          </div>
          <div>
            <span>{filsBroderie.length} couleur{filsBroderie.length > 1 ? "s" : ""} de fils</span><br/>
          </div>
        </div>
        <div className={"d-flex flex-wrap justify-content-around mb-3"}>
          {renderListeFils()}
        </div>
        <div className="text-right italic mt1">
            <Icons icon="help" size={15} color="black"/>
            <span className="pl05"><a className="grey text-underline" download href="/lib/pdf/MADEIRA_POLYNEON.pdf">Télécharger le nuancier des fils Madeira</a></span>
            <div className="small">Nous utilisons exclusivement la gamme Madeira Polyneon 40. Les couleurs sont données à titre indicatif.</div>
        </div>
      </Modal>
    );
  };

  return (
      <div className="my-2 w100">
        {filsBroderie?.length > 0 && <button  className={'align-items-center text-center d-flex btnBatAuto btnBatAutoPrimary justify-content-center py-3  black text-center w-100    cursor-pointer'} onClick={() => setDisplayFils(!displayFils)}>Voir les fils de broderie</button>}
        {filsBroderie?.length > 0 && displayFils && (
          renderModal()
        )}
      </div>
  );
}